/**
 * A deal total in its currency: `£322,500`, or `£323K` when compact. With no currency (the deals
 * carried none, or disagreed) the figure is shown bare, because a symbol would be a guess.
 */
export function formatMoney(amount: number, currency?: string | null, { compact = false } = {}): string {
  const shape: Intl.NumberFormatOptions = compact ? { notation: 'compact' } : { maximumFractionDigits: 0 }
  const bare = new Intl.NumberFormat(undefined, shape).format(amount)
  if (!currency) return bare
  try {
    return new Intl.NumberFormat(undefined, { ...shape, style: 'currency', currency }).format(amount)
  } catch {
    // A code Intl does not recognise is shown after the figure rather than dropped.
    return `${bare} ${currency}`
  }
}
